import React from 'react';
import styled, {css} from "styled-components";
import {GREY_4, LIGHT_PRIMARY, PRIMARY, WHITE} from "../../utils/colors";
import type {Moment} from 'moment';
import {useRoadSearchStore} from "../../store/roadSearch/roadSearchStore";
import {generateNextDates, previousValidTwoDays} from "../../utils/helpers";

type Props = {
    refetchSearch: () => void
}

const BusDateFilter = ({ refetchSearch }: Props) => {
    const {
        formData: {
            DepartureDate
        }, updateFormData,
    } = useRoadSearchStore();

    const previousDates = previousValidTwoDays(DepartureDate);
    const nextDates = generateNextDates(DepartureDate, (4 - previousDates.length));

    const handleDateChange = (date: Moment) => {
        updateFormData({
            DepartureDate: date
        });
        refetchSearch();
    }

    return (
        <Container>
            <Wrapper>
                {
                    previousDates.map((date, key) => (
                        <Item onClick={() => handleDateChange(date)} key={key}>
                            {date.format('ddd, DD MMM')}
                        </Item>
                    ))
                }

                <Item active>
                    {DepartureDate.format('ddd, DD MMM')}
                </Item>

                {
                    nextDates.map((date, index) => (
                        <Item onClick={() => handleDateChange(date)} key={index}>
                            {date.format('ddd, DD MMM')}
                        </Item>
                    ))
                }
            </Wrapper>
        </Container>
    );
};


export const Container = styled.div`
  width: 100%;
  background: ${WHITE};
  border-radius: 20px;
  padding: 10px;

  @media(max-width: 991px) {
    overflow-x:auto;
  }
`;

export const Wrapper = styled.div`
      display: flex;
      justify-content: space-between;
   
      @media(max-width: 991px) {
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap; 
        
        &::-webkit-scrollbar {
          display: none;
        }
      }
`;

export const Item = styled.div<{ active?: boolean}>`
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 8px;
  
   ${({ active }) => active && css`
     color: ${PRIMARY};
     cursor: default;
     background-color: ${LIGHT_PRIMARY};
   `};

    @media(max-width: 991px) {
      display: inline-block;
      margin-right: 30px;
    }
`;

export default BusDateFilter;
